import React from 'react'
import styled from '@emotion/styled'
import Spinner from '../generic/spinner.js'

export default () => (
  <LoadingDiv>
    <Spinner size="30px" />
  </LoadingDiv>
)

const LoadingDiv = styled.div`
  padding-top: 100px;
  display: flex;
  justify-content: center;
  height: 100vh;
`
